export default function Footer() {
  const cols = [
    {
      title: "内容板块",
      links: [
        { label: "正在现场", href: "#now" },
        { label: "弹幕合集", href: "#danmaku" },
        { label: "主播锐评", href: "#review" },
        { label: "反应视频", href: "#video" },
        { label: "热议榜", href: "#ranking" },
      ],
    },
    {
      title: "帮助与社区",
      links: [
        { label: "常见问题", href: "#faq" },
        { label: "投稿与报点", href: "#top" },
        { label: "互动规则", href: "#faq" },
        { label: "内容反馈", href: "#faq" },
      ],
    },
  ];

  return (
    <footer className="border-t border-orange-500/20 bg-[#16120f]">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500 text-white">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-display text-xl font-bold text-white">99吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-400">
              直播讨论、连麦现场、弹幕合集与反应视频一站式聚合，热门话题一出就有人开播陪看，吃瓜体验如同蹲在现场。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-stone-500">
              <i className="ri-mail-line text-orange-400" />
              <span>联系邮箱：hello@jiu-jiu-chigua.example.com</span>
            </div>
          </div>

          {cols.map((c) => (
            <nav key={c.title} className="md:col-span-2">
              <h4 className="mb-4 text-sm font-semibold text-white">{c.title}</h4>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-stone-400 transition-colors hover:text-orange-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="mb-4 text-sm font-semibold text-white">关注一起吃</h4>
            <p className="text-sm text-stone-500">开播、榜单上新，第一时间推给你。</p>
            <div className="mt-4 flex items-center gap-2">
              {["ri-send-plane-line", "ri-tiktok-line", "ri-video-line", "ri-wechat-line"].map((ic, i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="关注社交平台"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-lg text-stone-300 transition-colors hover:border-orange-400/50 hover:text-orange-300"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-stone-500">
            © {new Date().getFullYear()} 99吃瓜 直播讨论社区 · 内容均为演示信息，仅用于功能展示
          </p>
          <p className="flex items-center gap-1.5 text-xs text-stone-500">
            <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-orange-500" />
            现场持续开播中，欢迎来蹲
          </p>
        </div>
      </div>
    </footer>
  );
}